export type InvoiceLink = {
  url?: string;
};
